import { render, staticRenderFns } from "./LeftAside.vue?vue&type=template&id=28ddab12&scoped=true"
import script from "./LeftAside.vue?vue&type=script&lang=js"
export * from "./LeftAside.vue?vue&type=script&lang=js"
import style0 from "./LeftAside.vue?vue&type=style&index=0&id=28ddab12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ddab12",
  null
  
)

export default component.exports